// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten during build

export const VERSION_INFO = {
  "version": "2.1.1",
  "gitHash": "5118616",
  "lastUpdated": "2026-11-04",
  "buildDate": "2026-11-04",
  "migrationInfo": {
    "framework": "Next.js 15.5.2",
    "previousFramework": "React SPA with Vite",
    "migrationDate": "2025-09-11",
    "features": [
      "Static Site Generation (SSG)",
      "App Router",
      "Server Components",
      "Optimized builds",
      "Cloudflare Pages deployment ready"
    ]
  }
} as const;

/**
 * Get formatted version string for display
 */
export function getVersionString(): string {
  return `v${VERSION_INFO.version}`;
}

/**
 * Get git hash for display
 */
export function getGitHashString(): string {
  return VERSION_INFO.gitHash;
}

/**
 * Get formatted version with git hash for display
 */
export function getFullVersionString(): string {
  return `v${VERSION_INFO.version} (${VERSION_INFO.gitHash})`;
}

/**
 * Get formatted last updated string for display
 */
export function getLastUpdatedString(): string {
  const date = new Date(VERSION_INFO.lastUpdated);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Get formatted build date string for display
 */
export function getBuildDateString(): string {
  const date = new Date(VERSION_INFO.buildDate);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
